import { RotaryListUrlSortField } from "@saleor/rotary/urls";
import { RotarySortField } from "@saleor/types/globalTypes";
import { createGetSortQueryVariables } from "@saleor/utils/sort";

export function getSortQueryField(
  sort: RotaryListUrlSortField
): RotarySortField {
  switch (sort) {
    case RotaryListUrlSortField.name:
      return RotarySortField.THEME;
    case RotaryListUrlSortField.number:
      return RotarySortField.NUMBER;
    case RotaryListUrlSortField.isEnable:
      return RotarySortField.IS_ENABLE;
    case RotaryListUrlSortField.createDate:
      return RotarySortField.CREATE_DATE;
    case RotaryListUrlSortField.startDate:
      return RotarySortField.START_DATE;
    case RotaryListUrlSortField.endDate:
      return RotarySortField.END_DATE;
  }
}

export const getSortQueryVariables = createGetSortQueryVariables(
  getSortQueryField
);
